/**
 * Configuration constants for bulk deal documents upload
 */

export const BULK_UPLOAD_CONFIG = {
  /** Maximum file size in bytes (5GB) */
  MAX_FILE_SIZE: 5 * 1024 * 1024 * 1024,

  /** Allowed file type */
  ALLOWED_FILE_TYPE: '.zip',

  /** Polling interval for status updates in milliseconds */
  POLLING_INTERVAL_MS: 3000,

  /** Initial polling interval in milliseconds */
  INITIAL_POLLING_INTERVAL_MS: 3000,

  /** Maximum polling interval in milliseconds (for exponential backoff) */
  MAX_POLLING_INTERVAL_MS: 10000,

  /** Upload timeout in milliseconds (30 minutes) */
  UPLOAD_TIMEOUT_MS: 30 * 60 * 1000,

  /** Upload timeout in minutes (human-readable) */
  UPLOAD_TIMEOUT_MINUTES: 30,

  /** Maximum number of retry attempts for S3 upload */
  MAX_RETRY_ATTEMPTS: 3,

  /** Initial retry delay in milliseconds */
  INITIAL_RETRY_DELAY_MS: 1000,

  /** Maximum retry delay in milliseconds */
  MAX_RETRY_DELAY_MS: 5000,

  /** Default page size for main grid */
  DEFAULT_PAGE_SIZE: 20,

  /** Default page size for details modal */
  DETAILS_PAGE_SIZE: 50,
} as const;

export const SUPPORTED_DOCUMENT_TYPES = [
  'PDF (.pdf)',
  'Excel (.xlsx, .xls)',
  'Word (.docx, .doc)',
  'CSV (.csv)',
] as const;

export const FOLDER_STRUCTURE_EXAMPLE = `Fund Name/
  Company Name/
    YYYYMMDD-Round-Name/
      captable.xlsx
      closing-agreement.pdf`;
